// @ts-nocheck
// Compact badge for the slim header. Shows "התחברות" when signed-out,
// the user's email + "משוב" + "יציאה" when signed-in. Owns the
// AuthModal and ReviewForm toggles.

import { useState } from "react";
import { useAuth } from "../lib/useAuth";
import { useAdmin } from "../lib/useAdmin";
import { AuthModal } from "./AuthModal";
import { ReviewForm } from "./ReviewForm";

const styles = `
.auth-badge { display: inline-flex; align-items: center; gap: 6px; font-family: 'Heebo', sans-serif; font-size: 12px; line-height: 1; }
.auth-badge button { padding: 6px 12px; border-radius: 14px; font-family: inherit; font-size: 12px; font-weight: 500; cursor: pointer; transition: all .15s; white-space: nowrap; }
.auth-badge .ab-quiet { background: rgba(160,112,74,0.12); border: 1px solid rgba(160,112,74,0.25); color: #5C3D2E; }
.auth-badge .ab-quiet:hover { background: rgba(160,112,74,0.22); }
.auth-badge .ab-cta { background: linear-gradient(135deg, #A0704A, #D4875A); color: white; border: 1px solid #A0704A; box-shadow: 0 2px 8px rgba(160,112,74,0.32); font-weight: 600; padding: 7px 14px; }
.auth-badge .ab-cta:hover { background: linear-gradient(135deg, #8B5A35, #C0763E); transform: translateY(-1px); box-shadow: 0 3px 10px rgba(160,112,74,0.42); }
.auth-badge .auth-email { color: #8B7355; max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; min-width: 0; }
/* On narrow screens the full-text buttons collide with the chapter title in
   the slim header (Noam's screenshots, 1.8). Below 600px the buttons collapse
   to icons only — the aria-labels keep them accessible. Same pattern as the
   English fork. */
.auth-badge .ab-short { display: none; }
@media (max-width: 600px) {
  .auth-badge .auth-email { display: none; }
  .auth-badge { gap: 5px; }
  .auth-badge .ab-full { display: none; }
  .auth-badge .ab-short { display: inline; }
  .auth-badge button { padding: 6px 9px; }
}
`;

export function AuthBadge() {
  const { user, email, loading, signOut } = useAuth();
  const { isAdmin } = useAdmin();
  const [open, setOpen] = useState(false);
  const [reviewOpen, setReviewOpen] = useState(false);

  if (loading) return null; // avoid flash

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: styles }} />
      <div className="auth-badge">
        {user ? (
          <>
            <span className="auth-email" title={email || ""}>
              {email}
            </span>
            {isAdmin && (
              <button
                className="ab-quiet"
                onClick={() => {
                  window.location.href = "/admin";
                }}
                aria-label="פאנל ניהול"
              >
                <span className="ab-full">ניהול</span>
                <span className="ab-short">⚙</span>
              </button>
            )}
            <button
              className="ab-cta"
              onClick={() => setReviewOpen(true)}
              aria-label="משוב על הספר"
            >
              <span className="ab-full">✎ משוב</span>
              <span className="ab-short">✎</span>
            </button>
            <button
              className="ab-quiet"
              onClick={signOut}
              aria-label="יציאה"
            >
              <span className="ab-full">יציאה</span>
              <span className="ab-short">⏻</span>
            </button>
          </>
        ) : (
          <button className="ab-cta" onClick={() => setOpen(true)}>
            התחברות
          </button>
        )}
      </div>
      {open && <AuthModal onClose={() => setOpen(false)} />}
      {reviewOpen && user && (
        <ReviewForm onClose={() => setReviewOpen(false)} userId={user.id} />
      )}
    </>
  );
}
